import { onBeforeMount, ref, Ref } from 'vue';
import { closeLoader, openLoader } from '@utils/loader-util.js';

export function loadOnBeforeMount(toLoad: () => Promise<void>, withLoader: boolean = true): Ref<boolean> {
    const isLoading = ref<boolean>(true);

    onBeforeMount(async () => {
        if (withLoader) {
            openLoader();
            await toLoad();
            closeLoader();
        } else {
            await toLoad();
        }
        isLoading.value = false;
    });

    return isLoading;
}
